import {
  addEventToTracking,
  ApplicationNameType,
  mapProductForUserTracking
} from "@website/tracking/user";
import { CollapsibleTextPropertiesType } from "@website/ui/collapsible-text/collapsible-text.types";
import { useCallback, useEffect, useRef, useState } from "react";

export const useCollapsibleTextItem = (
  properties: CollapsibleTextPropertiesType
) => {
  const { content, ariaLabel, disabled, eventKey } = properties;
  const [collapsed, setCollapsed] = useState<boolean>(disabled ?? true);
  const [collapsible, setCollapsible] = useState<boolean>(true);
  const reference = useRef<HTMLDivElement>(null);

  const buttonId = `button-${ariaLabel.replaceAll(" ", "_")}`;
  const regionId = `region-${ariaLabel.replaceAll(" ", "_")}`;

  const onClick = useCallback(() => {
    properties.onButtonClick && properties?.onButtonClick();
    eventKey &&
      addEventToTracking(eventKey, {
        product: mapProductForUserTracking(
          process.env.NEXT_PUBLIC_APP_NAME as ApplicationNameType
        )
      });
    if (properties.hasCustomBehaviourButton) return;
    setCollapsed((state) => {
      const result = !disabled && !state;
      reference.current.style.height = result
        ? ""
        : `${reference.current?.scrollHeight ?? 100}px`;
      return result;
    });
  }, [disabled, eventKey]);

  useEffect(
    () =>
      setCollapsible(
        !disabled &&
          reference.current?.scrollHeight - reference.current?.clientHeight > 15
      ),
    [content, disabled]
  );

  return {
    regionProperties: {
      ref: reference,
      ...(collapsible && { "aria-labelledby": buttonId }),
      id: regionId,
      role: "region"
    },
    descriptionProperties: {
      children: content
    },
    buttonProperties: {
      "aria-controls": regionId,
      "aria-expanded": disabled || collapsed,
      "aria-label": disabled || collapsed ? "Show More" : "Show Less",
      "aria-disabled": disabled,
      disabled,
      id: buttonId,
      onClick
    },
    collapsed,
    collapsible
  };
};
